import React from 'react';
import { Input } from 'antd-mobile';

export interface TmsCountedInputProps {
  value: string;
  onChange: (val: string) => void;
  placeholder: string;
  maxLength?: number;
}

export const TmsCountedInput: React.FC<TmsCountedInputProps> = ({
  value,
  onChange,
  placeholder,
  maxLength = 50,
}) => {
  return (
    <div className="border border-gray-300 rounded relative">
      <Input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        className="py-1.5 px-2 pr-12 text-sm"
        style={{
          fontSize: '0.875rem',
          '--placeholder-color': '#999',
          '--placeholder-font-size': '0.5rem',
        } as any}
      />
      <span className="absolute inset-y-0 right-2 flex items-center text-xs text-gray-400">
        {value.length}/{maxLength}
      </span>
    </div>
  );
};

